  import {
    ApplicationConfig,
    provideZoneChangeDetection,
    importProvidersFrom,
    APP_INITIALIZER,
  } from '@angular/core';
  import {
    provideHttpClient,
    withInterceptors,
  } from '@angular/common/http';
  import { provideRouter, PreloadAllModules, withPreloading } from '@angular/router';
  import { i18nInterceptor } from './core/interceptors/i18n.interceptor';
  import { provideTranslateService } from '@ngx-translate/core';
  import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

  import { routes } from './app.routes';

  import { jwtInterceptor } from './core/interceptors/jwt.interceptor';
  import { appInitializer } from './app.initializer';

  // forms / ui
  import { FormsModule, ReactiveFormsModule } from '@angular/forms';
  import { MaterialModule } from './material.module';
  import { NgScrollbarModule } from 'ngx-scrollbar';
  import { providePrimeNG } from 'primeng/config';

  import { HcmPrimengPreset } from './core/theme/hcm-primeng-preset';
  import { provideAnimations } from '@angular/platform-browser/animations';

  export const appConfig: ApplicationConfig = {
    providers: [
      provideAnimations(),
      providePrimeNG({
        theme: {
          preset: HcmPrimengPreset,
          options: {
            /* Incluir .dark: el layout a veces solo pone dark en html/body sin dark-theme */
            darkModeSelector: '.dark-theme, html.dark, .dark, body.dark-theme, body.dark',
          },
        },
        /* Evita que dropdown/calendario se rendericen *dentro* del modal (por defecto Prime usa 'self'). */
        overlayAppendTo: 'body',
        /* Por encima del CDK/MatDialog y capas acumuladas del overlay stack (Prime calcula z-index inline) */
        zIndex: {
          modal: 200000,
          overlay: 200000,
          menu: 200000,
          tooltip: 200020,
        },
      }),

    provideZoneChangeDetection({ eventCoalescing: true }),
    // Precarga módulos para evitar el primer blanco.
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(withInterceptors( [jwtInterceptor, i18nInterceptor])),
    //provideAnimationsAsync(),
    //provideAnimations(),
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializer,
      multi: true,
    },

    provideTranslateService({
      loader: provideTranslateHttpLoader({
        // Ruta RELATIVA para que respete el `baseHref` (ej: /Hcm/) en despliegue.
        // Evita 404 cuando el loader intenta pedir `/assets/i18n/*.json` en lugar de `/Hcm/assets/i18n/*.json`.
        prefix: 'assets/i18n/',
        suffix: '.json',
      }),
    }),

    importProvidersFrom(FormsModule, ReactiveFormsModule, MaterialModule, NgScrollbarModule),
  ],
};
